<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn color="primary" small text v-on="on" @click="generate"
        ><v-icon small>mdi-arrow-top-right-bold-outline</v-icon>
      </v-btn>
    </template>
    <span>Generate</span>
  </v-tooltip>
</template>
<script>
export default {
  methods: {
    async generate() {
      this.$store.commit("uxModule/setShowLoader", true);
      let success = await this.$store.dispatch(
        "reportsModule/generateReportAssignments"
      );
      this.$store.commit("uxModule/setShowLoader", false);

      if (success) {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Successfully generated report assignments"
        );
      } else {
        this.$store.commit(
          "uxModule/setSnackbarMsg",
          "Error generating report assignments"
        );
      }
      this.$store.commit("uxModule/setShowSnackbar", true);
    },
  },
};
</script>
